import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    offsiteModalShow: false,
    accModalShow: false,
    source: 'authPage',
    isAuthorized: false,
    authorizedLoading: false,
    fresh: false,
};
const slice = createSlice({
    name: 'facebookReducer',
    initialState,
    reducers: {
        setFacebookModalShow(state, action) {
            const { offsiteModal, accModal, source } = action.payload;
            state.offsiteModalShow = offsiteModal !== null && offsiteModal !== void 0 ? offsiteModal : state.offsiteModalShow;
            state.accModalShow = accModal !== null && accModal !== void 0 ? accModal : state.accModalShow;
            state.source = source !== null && source !== void 0 ? source : state.source;
        },
        updateOAuth(state, action) {
            const { isAuthorized, authorizedLoading } = action.payload;
            state.isAuthorized = isAuthorized !== null && isAuthorized !== void 0 ? isAuthorized : state.isAuthorized;
            state.authorizedLoading = authorizedLoading !== null && authorizedLoading !== void 0 ? authorizedLoading : state.authorizedLoading;
        },
        freshFacebookPages(state, action) {
            const { fresh } = action.payload;
            state.fresh = fresh;
        },
    },
});
export const FacebookActions = slice.actions;
export default slice.reducer;
